"use strict";

var Ajaxinate = function (config) {
  var settings = config || {},
    defaultSettings = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,

      // state restore only
      restoreOnBack: true,
      storageKey: null
    };

  this.settings = Object.assign({}, defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.onPageShow = this.onPageShow.bind(this);
  this.saveState = this.saveState.bind(this);
  this.restoreStateIfAvailable = this.restoreStateIfAvailable.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.storageKey =
    this.settings.storageKey ||
    ("ajaxinate:" + window.location.pathname);

  if (this.settings.restoreOnBack) {
    this.restoreStateIfAvailable();
    window.addEventListener("pageshow", this.onPageShow);
  }

  window.addEventListener("scroll", this.saveState, { passive: true });
  document.addEventListener("click", this.saveState, true);

  this.initialize();
};

/* ---------- BFCache restore (Safari/iOS fix) ---------- */
Ajaxinate.prototype.onPageShow = function (e) {
  if (e && e.persisted) {
    this.restoreStateIfAvailable();
    this.initialize();
  }
};

Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement)
    this.containerElement = document.querySelector(this.settings.container);

  if (!this.paginationElement)
    this.paginationElement = document.querySelector(this.settings.pagination);

  if (!this.containerElement || !this.paginationElement) return;

  var initializers = {
    click: this.addClickListener,
    scroll: this.addScrollListeners
  };

  if (initializers[this.settings.method]) {
    initializers[this.settings.method]();
  }
};

/* ---------- Save loaded HTML + scroll ---------- */
Ajaxinate.prototype.saveState = function () {
  if (!this.settings.restoreOnBack) return;
  if (!this.containerElement || !this.paginationElement) return;

  try {
    var data = {
      scrollY: window.scrollY || 0,
      html: this.containerElement.innerHTML,
      pagination: this.paginationElement.innerHTML
    };

    sessionStorage.setItem(this.storageKey, JSON.stringify(data));
  } catch (e) {}
};

/* ---------- Restore collection state ---------- */
Ajaxinate.prototype.restoreStateIfAvailable = function () {
  if (!this.settings.restoreOnBack) return;

  try {
    var raw = sessionStorage.getItem(this.storageKey);
    if (!raw) return;

    var data = JSON.parse(raw);
    if (!data || !data.html) return;

    if (!this.containerElement)
      this.containerElement = document.querySelector(this.settings.container);

    if (!this.paginationElement)
      this.paginationElement = document.querySelector(this.settings.pagination);

    if (!this.containerElement || !this.paginationElement) return;

    this.containerElement.innerHTML = data.html;
    this.paginationElement.innerHTML = data.pagination || "";

    setTimeout(function () {
      window.scrollTo(0, data.scrollY || 0);
    }, 0);
  } catch (e) {}
};

/* ---------- Scroll load ---------- */
Ajaxinate.prototype.addScrollListeners = function () {
  if (!this.paginationElement) return;

  this.removeScrollListener();

  document.addEventListener("scroll", this.checkIfPaginationInView, { passive: true });
  window.addEventListener("resize", this.checkIfPaginationInView);
  window.addEventListener("orientationchange", this.checkIfPaginationInView);

  this.checkIfPaginationInView();
};

Ajaxinate.prototype.addClickListener = function () {
  if (!this.paginationElement) return;

  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.clickActive = true;

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  event.preventDefault();

  if (!this.clickActive || !this.nextPageLinkElement) return;

  this.nextPageLinkElement.innerHTML = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;

  this.clickActive = false;
  this.loadMore();
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  if (!this.paginationElement) return;

  var rect = this.paginationElement.getBoundingClientRect();
  var top = rect.top - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (!this.nextPageLinkElement) {
      this.removeScrollListener();
      return;
    }

    this.removeScrollListener();

    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;

    this.loadMore();
  }
};

Ajaxinate.prototype.loadMore = function () {
  if (!this.nextPageUrl) return;

  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function () {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      if (newContainer)
        this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);

      if (newPagination)
        this.paginationElement.innerHTML = newPagination.innerHTML;
      else
        this.paginationElement.innerHTML = "";

      if (this.settings.callback && typeof this.settings.callback === "function") {
        this.settings.callback(this.request.responseXML);
      }

      this.saveState();
      this.clickActive = true;
      this.initialize();
    }
  }.bind(this);

  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  this.removeScrollListener();
  window.removeEventListener("scroll", this.saveState);
  document.removeEventListener("click", this.saveState, true);
  window.removeEventListener("pageshow", this.onPageShow);

  return this;
};
